<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>banner管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="banner管理ID"
                        prop="id">
            <el-input placeholder="请输入banner管理ID"
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="banner管理名称"
                        prop="name">
            <el-input placeholder="请输入名称"
                      v-model="search.name"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel> -->
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/app-banner/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="app_types"
                         label="上架APP"
                         min-width="120">
          <template slot-scope="scope">
            <span>{{ formatAppTypes(scope.row.app_types) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="img"
                         label="图片"
                         min-width="120">
          <template slot-scope="scope">
            <el-image :src="scope.row.img" :preview-src-list="[scope.row.img]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="url"
                         label="图片链接"
                         min-width="140"></el-table-column>
        <el-table-column prop="priority"
                         label="优先级"
                         min-width="80"></el-table-column>
        <el-table-column prop="name"
                         label="PV/UV"
                         min-width="80">
          <template slot-scope="scope">
            <span>{{scope.row.pv}}/{{scope.row.uv}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="创建时间"
                         min-width="140"></el-table-column>
        <el-table-column prop="upshelftime"
                         label="上架时间"
                         min-width="140"></el-table-column>
        <el-table-column prop="downshelftime"
                         label="下架时间"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="140">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/app-banner/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">编辑
                </el-button>
              </router-link>
              <el-button type="danger"
                         size="mini"
                         @click="onDelete(scope.$index, table)">删除
              </el-button>
              <router-link :to="`/app-banner/logs/${scope.row.id}`">
                <el-button style="margin-top:2px" size="mini">查看历史记录</el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../app-banner.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: 'banner管理ID',
        },
        {
          key: 'name',
          text: 'banner管理名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    appTypeList: state => (state.order && state.order.options && state.order.options.app_type_list) || [],
  }),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getAppBannerTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportAppBannerData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteAppBannerData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    formatAppTypes (raw) {
      if (raw === undefined || raw === null || raw === '') {
        return '-'
      }
      const labelMap = {}
      this.appTypeList.forEach(item => {
        labelMap[Number(item.value)] = item.label
      })
      return String(raw)
        .split(',')
        .map(s => Number(String(s).trim()))
        .filter(v => labelMap[v])
        .map(v => labelMap[v])
        .join('、') || '-'
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/app-banner/pages/AppBannerTable.vue